import { Component, MouseEvent } from "react";
import { connect, ConnectedComponent } from "react-redux";
import { Field } from "redux-form";
import { ClientPortalPaymentModes } from "../../../../Common/organisationInfo";
import { addNotes } from "../../../Actions/confirmationActions";
import { IStore, IConfirmationStepInfo, BookingType } from "../../../DataTypes/storeTypes";
import TextArea from "../../../../Common/Form/TextArea";

interface IProps {
    stripeMode: ClientPortalPaymentModes;
    showNotes: boolean;
    showStripeFields: boolean;

    cdnHost: string;

    addNotes(e: MouseEvent<HTMLAnchorElement>);
}

class AppointmentNotes extends Component<IProps> {
    render() {
        return (
            <div className="summary-item note">
                <div className="summary-icon">
                    <img src={`${this.props.cdnHost}/images/confirmation/note.svg`} width="24" height="24" />
                </div>
                <div className="summary-text summary-notes">
                    {this.props.showNotes ? (
                        <div className="form-group">
                            <Field name="notes" placeholder="Notes" component={TextArea} />
                        </div>
                    ) : (
                        <a href="#" onClick={this.props.addNotes}>
                            Add Notes
                        </a>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps: IProps): IProps => {
    const info = state.stepsInfo[state.common.currentStep] as IConfirmationStepInfo;

    return {
        ...ownProps,
        showStripeFields: info.showStripe,
        showNotes: info.showAddNotes || state.initialSettings.type === BookingType.Class,
        cdnHost: state.initialSettings.cdnHost,
    };
};

const mapDispatchToProps = (dispatch, ownProps: IProps): IProps => {
    return {
        ...ownProps,
        addNotes: (e) => {
            e.preventDefault();
            dispatch(addNotes(true));
        },
    };
};

export const AppointmentNotesConnected: ConnectedComponent<typeof AppointmentNotes, any> = connect(
    mapStateToProps,
    mapDispatchToProps
)(AppointmentNotes);
